const BANNERS = {
    LIST_PAGE_VIEWED: {
        event: 'banner_list_page_viewed',
        eventProperties: {},
    },
    CREATE_SAVED: {
        event: 'banner_create_saved',
        eventProperties: {},
    },
    EDIT_SAVED: {
        event: 'banner_edit_saved',
        eventProperties: {},
    },
    DELETED: {
        event: 'banner_deleted',
        eventProperties: {},
    },
};

export default BANNERS;
